export default "__VITE_ASSET__DYQk1Xr3__"